import { render, staticRenderFns } from "./ForwardBackNav.vue?vue&type=template&id=1750411f&scoped=true&"
import script from "./ForwardBackNav.vue?vue&type=script&lang=js&"
export * from "./ForwardBackNav.vue?vue&type=script&lang=js&"
import style0 from "./ForwardBackNav.vue?vue&type=style&index=0&id=1750411f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1750411f",
  null
  
)

export default component.exports